import React, { PureComponent } from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import { postRequest } from "../../api/ApiService";
import SweetAlert from "sweetalert-react";

bootstrapUtils.addStyle(Button, "light-blue");

class TeamEdit extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      team_id: props.player.team,
      role: props.player.role,
      errorAlert: false,
      errorText: ""
    };
  }

  changeSelect = e => {
    const select = e.target;

    this.setState({
      [select.name]: select.value
    });
  };

  submit = () => {
    const { team_id, role } = this.state;
    const { game_id, player, updatedSuccessfully } = this.props;

    if (team_id > 0 && role !== "" && role !== player.role) {
      postRequest(
        `${process.env.REACT_APP_API_URL}games/${game_id}/change_team_role/`
      )
        .send({
          user: player.user.id,
          team: team_id,
          role
        })
        .then(res => {
          updatedSuccessfully();
          this.props.fetchData();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            const { user } = err.response.body;

            this.setState({
              errorAlert: true,
              errorText: user[0]
            });
          }
        });
    }
  };

  hideErrorAlert = () => {
    this.setState({
      errorAlert: false,
      errorText: ""
    });
  };

  render() {
    const { player, counter, teams } = this.props;
    const { team_id, role, errorAlert, errorText } = this.state;

    return (
      <tr>
        <td className="text-center v-align-middle instructor-round-number b-r">
          {counter}
        </td>
        <td className="b-l b-r v-align-middle instructor-td text-center">
          {player.user.username}
        </td>
        <td className="b-l b-r v-align-middle instructor-td">
          <select name="team_id" value={team_id} onChange={this.changeSelect}>
            {teams.map((team, index) => (
              <option key={index} value={team.id}>
                {team.name}
              </option>
            ))}
          </select>
        </td>
        <td className="b-l b-r v-align-middle instructor-td">
          <select name="role" value={role} onChange={this.changeSelect}>
            <option value="CEO">CEO</option>
            <option value="PD">Head of Product Development</option>
            <option value="PM">Head of Product Marketing</option>
            <option value="OP">Head of Operations</option>
            <option value="FI">Head of Finance</option>
          </select>
        </td>
        <td className="b-l">
          <Button bsStyle="light-blue" onClick={this.submit} block>
            Update
          </Button>
          <SweetAlert
            show={errorAlert}
            title="Error"
            text={errorText}
            type="error"
            onConfirm={this.hideErrorAlert}
          />
        </td>
      </tr>
    );
  }
}

export default TeamEdit;



// WEBPACK FOOTER //
// ./src/instructor/components/team-edit.js